/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsgBreakdown } from '../../models/esg-breakdown';
import { EsgFramework } from '../../models/esg-framework';
import { EsgYear } from '../../models/esg-year';

export interface DummyWorkaround$Params {
  a: EsgYear;
  b: EsgBreakdown;
  c: EsgFramework;
}

export function dummyWorkaround(http: HttpClient, rootUrl: string, params: DummyWorkaround$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, dummyWorkaround.PATH, 'patch');
  if (params) {
    rb.path('a', params.a, {});
    rb.path('b', params.b, {});
    rb.path('c', params.c, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

dummyWorkaround.PATH = '/dummy/workaround';
